<template>
  <div class="langClass">
    <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click" @command="choose">
      <span class="language">
        {{label}}
        <i class="el-icon-caret-bottom" />
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="(item, key ,i) in messages" :key="i" :command="key">{{ item.language }}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { messages } from '@/lang'
export default {
  props: ['active', 'toHome'],
  name: 'topMenu',
  data() {
    return {
      messages: messages
      // 如果在非temlate模版中取多语言的值的话，去使用this.$t('xxx')
    }
  },
  computed: {
    label() {
      return this.$t('table.label')
    }
  },
  methods: {
    choose(lang) {
      this.$i18n.locale = lang
      localStorage.setItem('lang', lang) //存下用户选择的语言
      if (this.toHome === true && lang === 'en') {
        this.$router.push('home')
      }
    }
  }
}
</script>

<style>
.language {
  cursor: pointer;
  color: #353535;
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/langMobile.vue